<div *ngIf="items.length" class="d-flex justify-content-between align-items-center mt-4 mb-3">
    <h3 class="">
        {{"pricing.Start Your Free Trial" | translate}}
    </h3>
    <div class="custom-switch-control d-flex justify-content-between align-items-center"
    >
        <button [disabled]="payPalLoading" class="btn btn-sm p-1 toggle-button"
                [ngClass]="{'highlight': activePlan.id === items[0].id}"
                (click)="switchPlan(items[0])">{{'pricing.' + items[0].frequency | translate}}</button>
        <i (click)="switchPlan(items[1])" *ngIf="activePlan.id === items[0].id"
           class="toggle highlight bi bi-toggle-off"></i>
        <i (click)="switchPlan(items[0])" *ngIf="activePlan.id === items[1].id"
           class="toggle highlight bi bi-toggle-on"></i>
        <button [disabled]="payPalLoading" class="btn btn-sm p-1 toggle-button"
                [ngClass]="{'highlight': activePlan.id === items[1].id}"
                (click)="switchPlan(items[1])">
            {{'pricing.' + items[1].frequency | translate}}</button>
    </div>
</div>
<lib-preloader [loading]="!items.length"></lib-preloader>
<div class="prices mb-5">
    <ng-container *ngFor="let item of items; let i=index">
        <div class="price-item" *ngIf="activePlan.id === items[i].id">
            <div class="value-wrapper"><span class="currency">$</span><span
                    class="value">{{item.value}}</span><span
                    class="period"><br>/{{"pricing.month" | translate}}</span></div>
            <p>{{"pricing." + item.title | translate}}</p>
        </div>
    </ng-container>
    <div class="free_trial_placeholder" *ngIf="items.length">
        {{"pricing.7-day Free Trial" | translate}}
    </div>
</div>
<div class="mt-5 order_details">
    <h3 class="mb-3">
        {{"pricing.Order Details" | translate}}
    </h3>
    <div class="d-flex justify-content-between align-items-center">
        <div>
            {{"pricing.Anima AI Companion" | translate}}
            <br>
            {{"pricing.Neuroscientific Tracker for anxiety, stress, burnout, and depression" | translate}}
            <br>
            {{"pricing.Personal Recommendations and Insights" | translate}}
        </div>
        <b class="pl-4">$0</b>
    </div>
    <hr>
    <div class="d-flex justify-content-between align-items-center">
        <div></div>
        <span>{{'pricing.Total' | translate}}: <b>$0</b></span>
    </div>
</div>


<div [hidden]="!isLoggedIn"  class="w-100 mt-4" [id]="'paypal-button-container'"></div>
<ngx-paypal *ngIf="isLoggedIn" class="w-100"
            [config]="payPalConfig"></ngx-paypal>
<ng-container *ngIf="!isLoggedIn">
    <button (click)="login()" class="btn btn-block btn-link  text-center justify-content-center">
        {{'pricing.Please login to proceed payment' | translate}}
    </button>
</ng-container>
<div class="powered-by mt-2 text-center">
    <span>Powered by</span><img src="assets/img/paypal.png" alt="paypal-icon"/>
</div>
<ng-container *ngIf="paymentError">
    <div>
        <h5>
            Oops!
        </h5>
        <p>
            It looks like something went wrong with your payment. No worries – just double-check your
            details or try a
            different payment method. Need a hand? We're here to help <a email="'support@anima.help'">support@anima.help</a>!
        </p>
    </div>
</ng-container>
